import React, { createContext, useEffect, useState } from 'react';
import { onAuthStateChanged, User as FirebaseUser } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { ProfileModel } from '../model/profile.model';
import { auth, db } from '../firebase/auth.firebase';
import { updateUserLastLogin, updateUserStatus } from '../services/api.service';


interface ProviderContextProps {
  user: ProfileModel | null;
  loading: boolean;
}

// Create the context
export const ProviderContext = createContext<ProviderContextProps>({
  user: null,
  loading: true,
});

// Provider component
export const ProviderContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<ProfileModel | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser: FirebaseUser | null) => {
      if (firebaseUser) {
        // Fetch additional user details from Firestore
        const userDoc = await getDoc(doc(db, 'users', firebaseUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data() as ProfileModel;
          updateUserStatus(firebaseUser.uid, "verified");
          updateUserLastLogin(firebaseUser.uid);
          setUser(userData);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <ProviderContext.Provider value={{ user, loading }}>
      {children}
    </ProviderContext.Provider>
  );
};
